module.exports = __webpack_public_path__ + "img/stake-to-mint-characters-gold.dd542233.png";